var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOriginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3487 9C18.3487 15.2222 9.67433 20.5556 9.67433 20.5556C9.67433 20.5556 1 15.2222 1 9C1 6.87827 1.9139 4.84344 3.54065 3.34315C5.1674 1.84285 7.37375 1 9.67433 1C11.9749 1 14.1813 1.84285 15.808 3.34315C17.4348 4.84344 18.3487 6.87827 18.3487 9Z",
    stroke: "#20A8E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6766 11.6668C11.2735 11.6668 12.568 10.4729 12.568 9.00016C12.568 7.5274 11.2735 6.3335 9.6766 6.3335C8.0797 6.3335 6.78516 7.5274 6.78516 9.00016C6.78516 10.4729 8.0797 11.6668 9.6766 11.6668Z",
    stroke: "#20A8E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginIcon);
export default __webpack_public_path__ + "static/media/origin_icon.e685486447a19f6fb8d034b6236c9f2b.svg";
export { ForwardRef as ReactComponent };